module.exports = __webpack_public_path__ + "iransans.8e858a3d7fcd56ed6123.eot";


//////////////////
// WEBPACK FOOTER
// D:/Projects/Yahoo/Server API/ServerAPI/AdminAngular/src/assets/fonts/iransans.eot
// module id = ../../../../../src/assets/fonts/iransans.eot
// module chunks = styles